// extracted by mini-css-extract-plugin
export var attribution = "fastly-info-map-module--attribution--e80dd";
export var fflogo = "fastly-info-map-module--fflogo--2ad94";
export var ffpromo = "fastly-info-map-module--ffpromo--c18ac";
export var info = "fastly-info-map-module--info--eea99";
export var map = "fastly-info-map-module--map--58667";
export var mapIcon = "fastly-info-map-module--mapIcon--ef7d3";
export var overlay = "fastly-info-map-module--overlay--e8730";
export var popName = "fastly-info-map-module--popName--224aa";
export var tags = "fastly-info-map-module--tags--b439a";
export var timeConnect = "fastly-info-map-module--timeConnect--0a661";
export var timeDns = "fastly-info-map-module--timeDns--7cf68";
export var timeOriginFetch = "fastly-info-map-module--timeOriginFetch--6534c";
export var timeRequest = "fastly-info-map-module--timeRequest--b77be";
export var timeResponse = "fastly-info-map-module--timeResponse--cc7a9";
export var timeline = "fastly-info-map-module--timeline--4d5a9";